import { css, keyframes } from "@emotion/css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { breadCrumbsAction } from "../../store/action/admin/themeActions";
import { Typography } from "antd";
import SearchBar from "./searchbar";
const { Text } = Typography;
const RTLiconHoverAnimation = keyframes`
  from {
    transform: translateX(-20px);
  }
  to {
    transform: translateX(3px);
  }
`;
const RTLiconHoverOutAnimation = keyframes`
  from {
    transform: translateX(25px);
    }
    to {
      transform: translateX(0px);
  }
`;

const textHoverAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const textHoverOutAnimation = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const LTRiconHoverAnimation = keyframes`
  from {
    transform: translateX(20px);
  }
  to {
    transform: translateX(-3px);
  }
`;
const LTRiconHoverOutAnimation = keyframes`
  from {
    transform: translateX(-25px);
    }
    to {
      transform: translateX(0px);
  }
`;

function AppHeaderIcons({
  isVisible,
  item,
  activeName,
  setMenuItem,
  onSideBarActive,
  onCancel,
}) {
  const themeDefault = useSelector((state) => state.themeDefault);
  const [headerHeight, setHeaderHeight] = useState(40); // State variable for header height

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 0) {
        setHeaderHeight(40); // Decrease header height on scroll
      } else {
        setHeaderHeight(40); // Original header height
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const getLanguageTranslatorList = useSelector(
    (state) => state.getLanguageTranslatorList
  );
  const { translations } = getLanguageTranslatorList;
  const sidebarItemStyles = (isActive) => css`
    color: ${isActive
      ? themeDefault?.info?.newConfig?.colorTextSecondary
      : themeDefault?.info?.newConfig?.color};
    background: ${isActive ? themeDefault?.info?.colorPrimary : "transparent"};
    overflow: hidden;
    border: 1px solid
      ${isActive
        ? themeDefault?.info?.colorPrimary
        : themeDefault?.info?.themeColor === "purple"
        ? "white"
        : themeDefault?.info?.themeColor === "dark"
        ? "rgba(255, 255, 255, 0.14)"
        : themeDefault?.info?.themeColor === "default"
        ? "#e0dcd9"
        : "#e0dcd9"};

    // box-shadow: ${isActive
      ? "0px 4px 10px 0px rgba(0, 0, 0, 0.08)"
      : "none"};
    cursor: pointer;
    border-radius: ${themeDefault?.info?.borderRadius}px;
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: background 0.3s ease-in-out, border 0.3s ease-in-out,
      height 0.3s ease-in-out, width 0.2s, transform 0.3s ease-in-out;

    gap: clamp(2px, 0.4vw, 6px);
    height: clamp(25px, 2.5vw, 40px);
    width: ${isActive ? "clamp(80px, 9vw, 135px)" : "clamp(50px, 4.6vw, 70px)"};

    justify-content: center;
    .sidebarIcon {
      color: ${isActive
        ? themeDefault?.info?.newConfig?.colorTextSecondary
        : themeDefault?.info?.newConfig?.color};
      transition: transform 0.3s ease-in-out;
      display: flex;
      animation: ${isActive
        ? ""
        : `${
            translations?.direction === "rtl"
              ? RTLiconHoverOutAnimation
              : LTRiconHoverOutAnimation
          } 0.2s forwards`};
    }
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .sidebarMenuText {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      // width: 200px;
      display: ${isActive ? "block" : "none"};
      animation: ${isActive ? "" : `${textHoverOutAnimation} 0.34s forwards`};
      color: ${themeDefault?.info?.newConfig?.colorTextSecondary};
      font-size: clamp(8px, 0.96vw, 14px);
    }

    &:hover {
      color: ${themeDefault?.info?.newConfig?.color};
      border: 1px solid ${themeDefault?.info?.colorPrimary};

      .sidebarIcon {
        color: ${isActive
          ? themeDefault?.info?.newConfig?.colorTextSecondary
          : themeDefault?.info?.newConfig?.color};
        animation: ${isActive
          ? ""
          : `${
              translations?.direction === "rtl"
                ? RTLiconHoverAnimation
                : LTRiconHoverAnimation
            } 0.2s forwards`};
      }

      .sidebarMenuText {
        color: ${isActive
          ? themeDefault?.info?.newConfig?.colorTextSecondary
          : themeDefault?.info?.newConfig?.color};
        animation: ${isActive ? "" : `${textHoverAnimation} 0.35s forwards`};
        display: block;
      }

      width: clamp(80px, 9vw, 135px);
    }
  `;
  //  border-left: ${translations?.direction === "ltr" ? "1px" : "4px"} solid
  //       ${themeDefault?.info?.colorPrimary} !important;
  //     border-right: ${translations?.direction === "rtl" ? "1px" : "4px"} solid
  //       ${themeDefault?.info?.colorPrimary} !important;

  const breadCrumbsList = useSelector((state) => state.breadCrumbsList);

  const isActive =
    activeName === item?.label1?.toLowerCase() ||
    // activeName === breadCrumbsList?.info?.toLowerCase() ||
    activeName === item?.category?.toLowerCase();
  const dispatch = useDispatch();
  // useEffect(() => {
  //   const handleCrumb = async (name) => {
  //     try {
  //       dispatch(breadCrumbsAction(name));
  //     } catch (error) {
  //       console.log({ error });
  //     }
  //   };
  //   handleCrumb(activeName);
  // }, [activeName]);

  return item?.show ? (
    item?.id === "maxAI" ? (
      <SearchBar
        item={item}
        setMenuItem={setMenuItem}
        onSideBarActive={onSideBarActive}
        onCancel={onCancel}
      />
    ) : // <div
    //   style={{ display: "flex" }}
    //   className={sidebarItemStyles(true)}
    //   onClick={() => onSearchOpen()}
    // >
    //   <div className="sidebarIcon">{item?.icon}</div>
    //   <Text className="sidebarMenuText">{item?.label}</Text>
    // </div>
    item?.isLink ? (
      <Link to={item?.link} style={{ display: "flex" }}>
        <div
          className={sidebarItemStyles(isActive)}
          onClick={() => {
            item.onClick();
            setMenuItem(item?.category);
            // handleCrumb(item?.label1?.toLowerCase());
            onSideBarActive(item?.label1?.toLowerCase());
          }}
        >
          <div className="sidebarIcon">{item?.icon}</div>
          <Text className="sidebarMenuText">{item?.label}</Text>
        </div>
      </Link>
    ) : (
      <div
        style={{ display: "flex" }}
        className={sidebarItemStyles(isActive)}
        onClick={(e) => {
          setMenuItem(item?.category);
          // handleCrumb(item?.label1?.toLowerCase());
          onSideBarActive(item?.label1?.toLowerCase());
          item.onClick(e);
        }}
      >
        <div className="sidebarIcon">{item?.icon}</div>
        <Text className="sidebarMenuText">{item?.label}</Text>
      </div>
    )
  ) : (
    <></>
  );
}

export default AppHeaderIcons;
